module.exports = __webpack_public_path__ + "img/checklist--white.b14b5734.svg";